import React, { useState, useEffect } from 'react';
import { useWeb3React } from "@web3-react/core";
import { toast } from 'react-toastify';
import { contract } from '../helper/contract';
import { getContract } from '../helper/contractHelper';
import managerAbi from '../json/poolManager.json';
import axios from 'axios';
import { getWeb3 } from '../helper/connectors';
import Button from 'react-bootstrap-button-loader';
import { parseEther } from 'ethers/lib/utils';
import localStorage from 'local-storage';

export default function PartnerDetails() {
    const context = useWeb3React();
    const { account, chainId, library } = context;
    const [error_msg, setError_msg] = useState('');
    const [btndisabled, setBtndisabled] = useState(false);
    const [input, setInput] = useState({
        fees: 0,
        address : ''
    });
    const [refresh, setRefresh] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [inputFields, setInputFields] = useState([{
        service: 'AMA',
    }]);

    useEffect(() => {
        async function fetchData() {
            let token = localStorage.get('token');
            let response = await axios.post(`${process.env.REACT_APP_API_URL}api/admin/get-profile`, {
                token,
                chainId
            });

            if (typeof response.data !== 'undefined' && response.data.error === 'OK') {
                delete response.data.data['password'];
                if(Object.keys(response.data.data).length > 0){
                    setInput({ address : response.data.data.address , fees: response.data.data.fees / Math.pow(10, 18) });
                    let details_array = response.data.data.details.split('+');
                    Promise.all(details_array.map((value) => {
                        return { service: value.toString().trim() }
                    })).then((response) => {
                        setInputFields(response);
                    })
                }
                else{
                    setInputFields([{service: 'AMA'}]);
                    toast.error('No Profile Found With Current Chainid!!');
                }

            }
            else {
                toast.error('Something went wrong ! try again');
            }
        }

        fetchData();
    }, [refresh,chainId])

    const addInputField = () => {

        setInputFields([...inputFields, {
            service: '',
        }])

    }
    const removeInputFields = (index, e) => {
        e.preventDefault();
        const rows = [...inputFields];
        rows.splice(index, 1);
        setInputFields(rows);
    }
    const handleChange = (index, evnt) => {
        const { name, value } = evnt.target;
        const list = [...inputFields];
        list[index][name] = value;
        setInputFields(list);
    }

    const handleOnChangeInput = (e) => {
        e.preventDefault();
        if (e.target.name === 'fees') {
            if (isNaN(e.target.value)) {
                setError_msg('please enter valid amount');
                setBtndisabled(true);
            }

            else if (e.target.value === '') {
                setError_msg('amount must be greater than zero');
                setBtndisabled(true);
            }
            else {
                setError_msg('');
                setBtndisabled(false);
            }
        }
        setInput({ ...input, [e.target.name]: e.target.value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (inputFields.length > 0 && account.toLowerCase() === input.address.toLowerCase()) {
                if (account && chainId) {
                    let poolContractAddress = contract[chainId] ? contract[chainId].poolmanager : contract['default'].poolmanager;
                    let poolManagerContract = getContract(managerAbi, poolContractAddress, library);
                    const rows = [...inputFields];
                    let serviceString = rows.map((product) => product.service).join('  +  ');
                    let tx = await poolManagerContract.partnerUpdateDetails( parseEther(input.fees.toString()), serviceString, { 'from': account });

                    const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 4000));
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            pending: 'Waiting for confirmation 👌',
                        }
                    )

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(chainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.success('success ! your last transaction is success 👍');
                                setLoading(false);
                                setRefresh(new Date());
                            }
                            else if (response.status === false) {
                                toast.error('error ! Your last transaction is failed.');
                                setLoading(false);
                            }
                            else {
                                toast.error('error ! something went wrong.');
                                setLoading(false);
                            }
                        }
                    }, 5000);

                }
                else {
                    toast.error('please connect to wallet !');
                    setLoading(false);
                }
            }
            else {
                toast.error('please enter valid details or connected wallet is not register!');
                setLoading(false);
            }
        }
        catch (err) {
            toast.error(err.reason ? err.reason : err.message);
            setLoading(false);
        }
    }

    return (
        <section class="pc-container">
            <div class="pcoded-content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h5>Update Details</h5>
                            </div>
                            <div class="card-body">
                                <form action="#" method="post">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="exampleInputPassword1">Price(In BNB)<span className='text-danger'>*</span></label>
                                                <input type="text" class="form-control" name="fees" placeholder="enter Price" value={input.fees} onChange={(e) => handleOnChangeInput(e)} />
                                                <span className='text-danger text-sm'>{error_msg}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <label for="exampleInputPassword1">Service Details<span className='text-danger'>*</span></label>
                                            {
                                                inputFields.map((data, index) => {
                                                    const { service } = data;
                                                    return (
                                                        <div className="row" key={index}>
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <input type="text" onChange={(evnt) => handleChange(index, evnt)} value={service} name="service" className="form-control" placeholder="Enter service details.." />
                                                                </div>
                                                            </div>

                                                            <div className="col">
                                                                {(inputFields.length !== 1) ? <button className="btn btn-danger" onClick={(e) => removeInputFields(index, e)}>x</button> : ''}
                                                            </div>
                                                        </div>
                                                    )
                                                })

                                            }
                                            <div className="col-md-12">
                                                <button className="btn btn-outline-success" type="button" onClick={(e) => addInputField(e)}>Add New</button>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <Button loading={loading} disabled={btndisabled} onClick={(e) => handleSubmit(e)} class="btn btn-primary">Submit</Button>
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <span className='text-danger'>*take upto 1 minutes to updated details show</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </section >
    )
}
